import React, { createContext, useContext, useState, useCallback } from 'react';

const STORAGE_KEY = 'selectedDb';
export const ALLOWED_DBS = ['dse12app_production', 'dse12app_demo'];
export const DEFAULT_DB = 'dse12app_production';

export function getStoredDb() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return ALLOWED_DBS.includes(v) ? v : DEFAULT_DB;
  } catch {
    return DEFAULT_DB;
  }
}

const DbContext = createContext(null);

export const useDb = () => {
  const ctx = useContext(DbContext);
  if (!ctx) throw new Error('useDb must be used within a DbProvider');
  return ctx;
};

export const DbProvider = ({ children }) => {
  const [dbName, setDbNameState] = useState(getStoredDb);

  const setDbName = useCallback((name) => {
    const next = ALLOWED_DBS.includes(name) ? name : DEFAULT_DB;
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // ignore storage errors (private mode, etc.)
    }
    setDbNameState(next);
  }, []);

  return (
    <DbContext.Provider value={{ dbName, setDbName, allowedDbs: ALLOWED_DBS }}>
      {children}
    </DbContext.Provider>
  );
};
